import { Button, ButtonProps } from "@silversea-ssc/ui-components-react";
import React, { ReactNode } from "react";
import { useHits, useCurrentRefinements } from "react-instantsearch";

export type ButtonWithCruiseCounterLabel = (
  appliedFiltersCount: number,
  resultsFoundCount: number
) => ReactNode;
type Props = Omit<ButtonProps, "key"> & {
  label?: ButtonWithCruiseCounterLabel;
};

export const ButtonWithCruiseCounter: React.FC<Props> = ({
  label,
  ...props
}) => {
  const { results } = useHits();
  const { items } = useCurrentRefinements();
  const resultsFoundCount = results?.nbHits || 0;
  const appliedFiltersCount = items.flatMap((i) => i.refinements).length;

  return (
    <Button {...(props as ButtonProps)}>
      {label && label(appliedFiltersCount ?? 0, resultsFoundCount ?? 0)}
    </Button>
  );
};
